// One of the screen's two sections: office overhead, or the costs that sit on work.
//
// A COMPONENT RATHER THAN TWO BLOCKS IN THE PAGE, because the sections differ in two
// values — heading, and whether a row names the engagement it belongs
// to — and in nothing else. They are the same table over the same rows split on `job_id`
// (migration 026), so anything else that told them apart would be an accident.
//
// IT IS ALWAYS RENDERED, EMPTY OR NOT, and says which kind of nothing it holds. This is
// the היום שלי rule and it matters more here: a section that disappeared when it had no
// rows would make "no office costs are outstanding" indistinguishable from "the office
// section is gone", on the one screen whose job is to say what is still owed.
import DataTable from '../../components/DataTable';
import { expenseColumns } from './expenseColumns';

export default function ExpenseSection({
  section, title, rows, empty, paid, lookups, onMarkPaid, onEdit, onDelete,
}) {
  return (
    <div className="card w-section">
      <h2>{title}</h2>
      <DataTable
        // `scroll` because the job section is genuinely wide — the engagement column plus
        // two dates in the archive — and a table that stays a table and scrolls reads
        // better than one squeezed to nothing. On phones responsive.css turns it into
        // cards regardless, so nothing is lost there.
        scroll
        columns={expenseColumns({ paid, section, lookups, onMarkPaid, onEdit, onDelete })}
        rows={rows}
        empty={{ text: empty }}
      />
    </div>
  );
}
